import { render } from "./RawMaterialIoWarehouse.vue?vue&type=template&id=3bcc438c&scoped=true"
import script from "./RawMaterialIoWarehouse.vue?vue&type=script&lang=js"
export * from "./RawMaterialIoWarehouse.vue?vue&type=script&lang=js"

import "./RawMaterialIoWarehouse.vue?vue&type=style&index=0&id=3bcc438c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bcc438c"

export default script